import React from "react";

// reactstrap components
import {

  Container

} from "reactstrap";

// core components
import ColorNavbar from "components/Navbars/ColorNavbar.js";
import downloadPdfFromJson from "utils/downloadPdfFromJson.js";


function GestionInformacion() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("about-us");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("about-us");
    };
  });
  return (
    <>
      <ColorNavbar />
      <div className="main" style={{ marginTop: "10em" }}>
        <div className="section">
          <Container>
            <center className="mt-5">
              <a
                href="#registro-de-activos-de-la-informacion"
                role="button"
                style={{ textDecoration: "none !important", cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  downloadPdfFromJson(
                    "/registro-de-activos-de-la-informacion.json",
                    "registro-de-activos-de-la-informacion.pdf"
                  );
                }}
              >
                <img
                  alt="Imagen con referencia Registro Activos"
                  width="80px"
                  src={require("assets/img/sections/pdf.jpg")}
                ></img>
                <h6 className="my-3">Registro de Activos</h6>
              </a>
            </center>
            <center className="mt-5">
              <a
                href="#esquema-de-publicacion-de-la-informacion"
                role="button"
                style={{ textDecoration: "none !important", cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  downloadPdfFromJson(
                    "/esquema-de-publicacion-de-la-informacion.json",
                    "esquema-de-publicacion-de-la-informacion.pdf"
                  );
                }}
              >
                <img
                  alt="Imagen con referencia Publicacion Informacion"
                  width="80px"
                  src={require("assets/img/sections/pdf.jpg")}
                ></img>
                <h6 className="my-3">ESQUEMA DE PUBLICACION DE LA INFORMACION</h6>
              </a>
            </center>
            <center>
              <a
                href="http://datos.gov.co/"
                target="_black"
                style={{
                  fontWeight: 500,
                  fontFamily: "'Noto Sans SC', sans-serif",
                  cursor: 'pointer'
                }}
              >
                Enlace a Datos Abiertos
              </a>
            </center>
          </Container>
        </div>
      </div>
    </>
  );
}

export default GestionInformacion;
